import type { ChatChannelConfig } from '@oneToOne/shared/services/rest/types'

/**
 * Determines if the widget is online.
 * Online means, there are agents available or it is within office hours.
 */
export const isOnline = (chatChannelConfig: ChatChannelConfig | undefined) => {
  switch (chatChannelConfig?.config?.widget_availability) {
    case 'by_agent_availability':
      return !!chatChannelConfig.config.agent_available
    case 'by_office_hours':
      return !!chatChannelConfig.config.within_office_hours
    default:
      return false
  }
}
